import { LitElement, html, css } from 'lit'
import './snap-scroller'

customElements.define('k-gallery', class extends LitElement{

    static properties = {
        num: {type: Number, reflect: true}
    }

    static styles = css`
        :host {
            --gap: 1em;
            --size: clamp(33vw, 80vw, 600px);
            --img-height: 100%;
        }

        :host([fullwidth]) {
            width: 100vw;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            --spacer: calc((100vw - var(--content-w))/2);
            --padding: 1em var(--content-pad);
            max-height: 70vh;
            display: block;
        }

        k-snap-scroller {
            --spacer: 0;
        }

        :host([num="1"]) {
            --size: 100%;
        }

        :host([num="2"]) {
            --size: calc(50% - var(--gap));
        }

        @media (max-width: 699px) {
            :host([num="2"]) {
                --size: 80%
            }
        }
        
    `

    firstUpdated(){
        setTimeout(() => {
            this.num = this.children.length
            this.toggleAttribute('fullwidth', this.num > 2)
        }, 10)
    }

    render(){return html`
        <k-snap-scroller ?buttons=${this.num > 2}>
            <slot></slot>
        </k-snap-scroller>
    `}

})

export default customElements.get('k-gallery')